import React from 'react';
import FieldView from "../../../../components/FieldView";
import {formDefFazendaCorte} from "../forms";
import {QuestionarioFazendaObject} from "../../../../models/Questionario";
import {FazendaObject} from "../../../../models/Fazenda";

interface QuestionarioCorteV2Props {
  questionario: QuestionarioFazendaObject
  principal: FazendaObject;
}

const QuestionarioCorteV2: React.FC<QuestionarioCorteV2Props> = (props) => {
  const {questionario, principal} = props;

  return (
    <>
      <div className="text-xl font-hairline mt-6">
        Fazendas de corte
      </div>
      <FieldView value={questionario.data_inicio_em}
                 def={formDefFazendaCorte.data_inicio_em}/>
      <FieldView value={questionario.femeas_submetidas_iatf}
                 def={formDefFazendaCorte.femeas_submetidas_iatf}/>
      <FieldView value={questionario.bezerros_nascidos}
                 def={formDefFazendaCorte.bezerros_nascidos}/>
      <FieldView value={questionario.bezerros_desmamados}
                 def={formDefFazendaCorte.bezerros_desmamados}/>

      <div className="text-xl font-hairline mt-6">
        Rebanho de Corte
      </div>
      {
        principal.sistema_producao.indexOf('Cria') !== -1 &&
          <>
            <div className="text-xl font-hairline mt-4">
              Cria
            </div>
            <FieldView value={questionario.corte_cria_vacas}
                       def={formDefFazendaCorte.corte_cria_vacas}/>
            <FieldView value={questionario.corte_cria_novilhas}
                       def={formDefFazendaCorte.corte_cria_novilhas}/>
            <FieldView value={questionario.corte_cria_bezerros}
                       def={formDefFazendaCorte.corte_cria_bezerros}/>
            <FieldView value={questionario.corte_cria_touros}
                       def={formDefFazendaCorte.corte_cria_touros}/>
          </>
      }
      {
        principal.sistema_producao.indexOf('Recria') !== -1 &&
          <>
            <div className="text-xl font-hairline mt-4">
              Recria
            </div>
            <FieldView value={questionario.corte_recria_novilhas}
                       def={formDefFazendaCorte.corte_recria_novilhas}/>
            <FieldView value={questionario.corte_recria_garrotes}
                       def={formDefFazendaCorte.corte_recria_garrotes}/>
          </>
      }
      {
        principal.sistema_producao.indexOf('Engorda') !== -1 &&
          <>
            <div className="text-xl font-hairline mt-4">
              Engorda
            </div>
            <FieldView value={questionario.corte_engorda_bois}
                       def={formDefFazendaCorte.corte_engorda_bois}/>
            <FieldView value={questionario.corte_engorda_femeas}
                       def={formDefFazendaCorte.corte_engorda_femeas}/>
          </>
      }
      {
        principal.sistema_producao.indexOf('Confinamento') !== -1 &&
          <>
            <div className="text-xl font-hairline mt-4">
              Confinamento
            </div>
            <FieldView value={questionario.corte_confinamento_machos}
                       def={formDefFazendaCorte.corte_confinamento_machos}/>
            <FieldView value={questionario.corte_confinamento_femeas}
                       def={formDefFazendaCorte.corte_confinamento_femeas}/>
          </>
      }
    </>
  );
}

export default QuestionarioCorteV2;
